import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';

var config = {
  apiKey: 'AIzaSyDrGfs89AoY3zsvXd3A49RCY-Bfdv4oORI',
  authDomain: 'slackchatapp-3069e.firebaseapp.com',
  databaseURL: 'https://slackchatapp-3069e.firebaseio.com',
  projectId: 'slackchatapp-3069e',
  storageBucket: 'slackchatapp-3069e.appspot.com',
  messagingSenderId: '930937326741',
};
firebase.initializeApp (config);

export default firebase;



// WEBPACK FOOTER //
// ./src/firebase.js